import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledAdd: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_add"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="add icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M12.0002 3C12.3907 3 12.7135 3.29008 12.7647 3.66662L12.7718 3.7713L12.773 11.2289H20.2336C20.6597 11.2289 21.0051 11.5743 21.0051 12.0004C21.0051 12.3909 20.7149 12.7137 20.3383 12.7648L20.2336 12.7718H12.773L12.7751 20.2284C12.7752 20.6544 12.4299 21 12.0038 21C11.6132 21 11.2904 20.7099 11.2393 20.3334L11.2322 20.2287L11.2301 12.7718H3.77366C3.34759 12.7718 3.0022 12.4264 3.0022 12.0004C3.0022 11.6098 3.29243 11.287 3.66898 11.236L3.77366 11.2289H11.2301L11.2288 3.77162C11.2288 3.34555 11.5741 3 12.0002 3Z" />
      </svg>
    </span>
  );
};

export { FilledAdd };
